module.exports = function fail(message) {
  throw new TypeError('[tcomb] ' + message);
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/fail.js
// module id = 745
// module chunks = 114276838955818